export default function Button({ text, href, type }) {
    return (
        <a href={href}>
            <button type='button' className={type}>{text}</button>
        </a>
    )
}